import React from 'react';
import SemanticModal from "semantic-ui-react/dist/es/modules/Modal/Modal.js";
import { GridColumn } from "../../../layout/GridColumn";
import { GridRow } from "../../../layout/GridRow";
import { Grid } from "../../../layout/Grid";
import { Link } from "../../../elements/Link";
import { Modal } from "../../../elements/Modal";
import { getCategoryMarkup } from "./getCategoryMarkup";
export var getExtraItemsMarkup = function getExtraItemsMarkup(hasExtraItemsInModal, modalTriggerText, amenities, amenitiesConjunctionText) {
  return hasExtraItemsInModal ? React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Modal, {
    hasPadding: true,
    trigger: React.createElement(Link, null, modalTriggerText)
  }, React.createElement(SemanticModal.Content, null, React.createElement(Grid, {
    className: "is-amenities",
    columns: 1,
    isStackable: true,
    padded: true
  }, React.createElement(GridRow, null, amenities.map(function (amenity, index) {
    return getCategoryMarkup(amenity, index, amenitiesConjunctionText);
  })))))) : amenities.map(function (amenity, index) {
    return getCategoryMarkup(amenity, index, amenitiesConjunctionText);
  });
};